import { client } from "@lib/api"
import useSWR from "swr"

type ReferralDetails = {
    referral_code: string
    reward_amount: number
    limit: number
    used: number
    program_referrer_reward_amount?: number
    program_minimum_top_up_amount?: number
    description?: string
}

const useReferralReward = () => {
    const { data, isLoading, error } = useSWR('/v2/wallet/referral', client.doGet)

    return {
        data: data as ReferralDetails | undefined,
        isLoading,
        error
    }
}

export default useReferralReward
